import React from 'react';
import { Button } from 'reactstrap';

/**
 * Barre de pagination — à placer en haut des listes (avant tableau / contenu).
 */
export default function ListPagination({
  page = 1,
  totalPages = 1,
  onPageChange,
  isLoading = false,
  hidden = false,
  className = 'mb-3 mt-2',
  align = 'end',
  prevDisabled,
  nextDisabled,
}) {
  if (hidden) return null;

  const currentPage = Number(page) || 1;
  const maxPages = Math.max(1, Number(totalPages) || 1);
  const justify = align === 'center' ? 'center' : 'end';

  const isPrevDisabled =
    prevDisabled ?? (isLoading || currentPage <= 1);
  const isNextDisabled =
    nextDisabled ?? (isLoading || currentPage >= maxPages);

  return (
    <div
      className={`d-flex gap-3 justify-content-${justify} align-items-center flex-wrap ${className}`}
    >
      <Button
        color='secondary'
        size='sm'
        disabled={isPrevDisabled}
        onClick={() => onPageChange((p) => Math.max(1, p - 1))}
      >
        Précédent
      </Button>
      <p className='text-center mb-0'>
        Page <span className='text-primary'>{currentPage}</span> sur{' '}
        <span className='text-info'>{maxPages}</span>
      </p>
      <Button
        color='primary'
        size='sm'
        disabled={isNextDisabled}
        onClick={() => onPageChange((p) => p + 1)}
      >
        Suivant
      </Button>
    </div>
  );
}
